import React, { useState } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import DeletePopup from "../../Components/DeletePopup";
import EditDegreePopup from "./EditDegreePopup";
import { deleteDegree } from "../../redux/actions/degreeActions";
import { useDispatch,useSelector } from "react-redux";

export default function DegreeList({ degreesFilter }) {
  const dispatch = useDispatch();
  const [editingDegree, setEditingDegree] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(degreesFilter.length / itemsPerPage);
  const paginatedDegrees = degreesFilter.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (e) => setCurrentPage(Number(e.target.value));

  const handleEdit = (degree) => {
    setEditingDegree(degree);
    setIsEditOpen(true);
  };

  const handleDelete = (degree) => {
    setEditingDegree(degree);
    setIsDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    // Perform delete action
    setIsDeleteOpen(false);
    setEditingDegree(null);
     if (editingDegree) {
          dispatch(deleteDegree(editingDegree.id));
          setIsDeleteOpen(false);
        }
  };

  return (
    <div className="relative p-4 bg-white rounded-lg shadow-md">
      {/* Pagination */}
      <div className="flex justify-end mb-4">
        <select
          className="px-4 py-2 border border-gray-300 rounded-md"
          value={currentPage}
          onChange={handlePageChange}
        >
          {Array.from({ length: totalPages }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
      </div>

      {/* Degree List Table */}
      <div className="overflow-x-auto scrollbar-custom max-h-96">
        <table className="min-w-full border border-gray-300 table-auto">
          <thead>
            <tr className="text-left text-gray-600 bg-gray-100">
              <th className="px-16 py-2">PROGRAM NAME</th>
              <th className="px-16 py-2">OFFERING UNIVERSITY</th>
              <th className="px-16 py-2">RECOGNIZED BY</th>
              <th className="px-16 py-2">DEPARTMENT</th>
              <th className="px-16 py-2">APPROVED BY</th>
              <th className="px-16 py-2">TYPE</th>
              <th className="px-16 py-2">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {paginatedDegrees.map((deg) => (
              <tr key={deg.id} className="border-b border-gray-300">
                <td className="px-16 py-2">{deg.program_name }</td>
                <td className="px-16 py-2">{deg.offering_university}</td>
                <td className="px-16 py-2">{deg.recognized_by}</td>
                <td className="px-16 py-2">{deg.department_name}</td>
                <td className="px-16 py-2">{deg.approved_by }</td>
                <td className="px-16 py-2">
                  <span className="px-2 py-1 text-sm font-semibold rounded text-primary-color bg-primary-color bg-opacity-10">
                    {deg.degree_type }
                  </span>
                </td>
                <td className="px-12 py-2">
                  <div className="flex items-center space-x-4">
                    <button
                      type="button"
                      className="flex items-center px-1 py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                      onClick={() => handleDelete(deg)}
                    >
                      <MdOutlineDeleteForever className="w-5 h-5 mx-2" />
                    </button>
                    <button
                      type="button"
                      className="flex items-center px-1 py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                      onClick={() => handleEdit(deg)}
                    >
                      <FaRegEdit className="w-4 h-4 mx-2" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Delete Popup */}
      {isDeleteOpen && (
        <DeletePopup
          title="Degree"
          isOpen={isDeleteOpen}
          onClose={() => setIsDeleteOpen(false)}
          onConfirm={handleConfirmDelete}
          data={editingDegree?.program_name || ""}
        />
      )}

      {/* Edit Popup */}
      {isEditOpen && (
        <EditDegreePopup
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          initialData={editingDegree}
        />
      )}
    </div>
  );
}

